import React from "react";
import "./PageNotFound.css";
import { NavLink } from "react-router-dom";
import SeoHead from "../Common/SeoHead";

const PageNotFound = () => {
  return (
    <section className="page-not-found">
      <SeoHead
        title="Page Not Found | CAJobPortal"
        description="The page you are looking for is not available on CAJobPortal."
        path="/404"
        noindex
      />
      <div className="page-not-found__content">
        <p className="page-not-found__eyebrow">Error 404</p>
        <h1 className="page-not-found__title">Oops! The page can&apos;t be found</h1>
        <p className="page-not-found__description">
          The page you are looking for may have been moved, removed, or might
          never have existed.
        </p>

        <div className="page-not-found__actions">
          <NavLink className="page-not-found__button" to="/">
            Go To Homepage
          </NavLink>
          <button
            className="page-not-found__link"
            type="button"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>

        <div className="page-not-found__code" aria-hidden="true">
          404
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;
